export type SendSms = {
	Sent: boolean;
};

export enum SendSmsOption {
	Message = 'message-content',
	PhoneNumber = 'phone-numbers',
}

export type SendSmsOptions = {
	Message: string;
	PhoneNumber: string;
};
